import { render, staticRenderFns } from "./ImpressaoBloco.vue?vue&type=template&id=0018eff6&scoped=true&"
import script from "./ImpressaoBloco.vue?vue&type=script&lang=js&"
export * from "./ImpressaoBloco.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoBloco.vue?vue&type=style&index=0&id=0018eff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018eff6",
  null
  
)

export default component.exports